import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { Grid, Stack } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderKanbanModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [lanes, setLanes] = useState([]);
  const [selectedLane, setSelectedLane] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    console.log("FlowBuilderKanbanModal - open:", open);
    if (open === "edit") {
      (async () => {
        try {
          const lane = data.data.lane;
          const selectedUserData = data.data.user;
          const { data: result } = await api.get("/tag/kanban");
          const { data: usersResult } = await api.get("/users/");
          
          setSelectedLane(lane.id);
          setSelectedUser(selectedUserData?.id || "");
          setLanes(result.lista || []);
          setUsers(usersResult.users || []);
          setActiveModal(true);
        } catch (error) {
          console.log("Erro ao carregar etapas (edit):", error);
          toast.error("Erro ao carregar etapas do kanban");
          setLanes([]);
          setUsers([]);
          setActiveModal(true);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          console.log("Buscando etapas do kanban...");
          const response = await api.get("/tag/kanban");
          const usersResponse = await api.get("/users/");
          
          console.log("Resposta completa:", response);
          console.log("Etapas recebidas:", response.data);
          
          setSelectedLane("");
          setSelectedUser("");
          setLanes(response.data.lista || []);
          setUsers(usersResponse.data.users || []);
          setActiveModal(true);
        } catch (error) {
          console.log("Erro ao carregar etapas (create):", error);
          console.log("Detalhes do erro:", error.response);
          toast.error("Erro ao carregar etapas do kanban. Verifique se existem etapas cadastradas.");
          setLanes([]);
          setUsers([]);
          setActiveModal(true);
        }
      })();
    } else {
      setActiveModal(false);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (!selectedLane) {
      return toast.error("Selecione uma etapa do kanban");
    }
    if (!selectedUser) {
      return toast.error("Selecione um usuário");
    }
    
    if (open === "edit") {
      const lane = lanes.find((item) => item.id === selectedLane);
      const user = users.find((item) => item.id === selectedUser);

      onUpdate({
        ...data,
        data: {
          lane: lane ? lane : "",
          user: user ? user : "",
        },
      });
    } else if (open === "create") {
      const lane = lanes.find((item) => item.id === selectedLane);
      const user = users.find((item) => item.id === selectedUser);

      onSave({
        lane: lane ? lane : "",
        user: user ? user : "",
      });
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {open === "create" ? `Adicionar etapa do kanban ao fluxo` : `Editar etapa do kanban`}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Grid style={{ width: "100%", marginTop: 40 }} container spacing={2}>
              <Grid item xs={12}>
                <Typography>Escolha uma etapa do kanban</Typography>
                <Select
                  labelId="kanban-lane-select-label"
                  id="kanban-lane-select"
                  value={selectedLane}
                  style={{ width: "95%" }}
                  onChange={(e) => {
                    setSelectedLane(e.target.value);
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  renderValue={() => {
                    if (selectedLane === "") {
                      return "Selecione uma etapa";
                    }
                    const lane = lanes.find((l) => l.id === selectedLane);
                    if (lane === undefined) {
                      return "Nenhuma etapa selecionada";
                    }
                    return lane.name;
                  }}
                >
                  <MenuItem value="">
                    <em>Selecione uma etapa</em>
                  </MenuItem>

                  {lanes.length > 0 &&
                    lanes.map((lane, index) => (
                      <MenuItem dense key={index} value={lane.id}>
                        {lane.name}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>

              <Grid item xs={12}>
                <Typography>Escolha um usuário</Typography>
                <Select
                  labelId="kanban-user-select-label"
                  id="kanban-user-select"
                  value={selectedUser}
                  style={{ width: "95%" }}
                  onChange={(e) => {
                    setSelectedUser(e.target.value);
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  renderValue={() => {
                    if (selectedUser === "") {
                      return "Selecione um usuário";
                    }
                    const user = users.find((u) => u.id === selectedUser);
                    if (user === undefined) {
                      return "Nenhum usuário selecionado";
                    }
                    return user.name;
                  }}
                >
                  <MenuItem value="">
                    <em>Selecione um usuário</em>
                  </MenuItem>

                  {users.length > 0 &&
                    users.map((user, index) => (
                      <MenuItem dense key={index} value={user.id}>
                        {user.name}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.btnWrapper}
              onClick={handleSave}
            >
              {open === "create" ? `Adicionar` : "Editar"}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderKanbanModal;
